export default __webpack_public_path__ + "static/media/Indian_Roller_Bird_at_Bandhavgarh_National_Park.7eb82cd4.jpg";